var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _c(
      "div",
      { staticClass: "login-form" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("p", { staticClass: "login-title" }, [
          _vm._v(_vm._s(_vm.$t("login.welcome"))),
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "login-button",
            attrs: { loading: _vm.loading, type: "primary" },
            nativeOn: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.handleLogin($event)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.$t("login.ssoLogin")) + "\n    ")]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-banner" }, [
      _c("img", {
        attrs: { src: require("@/assets/login/logo.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footer" }, [
      _c("span", [_vm._v("沪ICP备14018533号")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }